import { BiCheck } from "react-icons/bi";
import styled from "styled-components";

export const BasketWrapper = styled.div<{marginTop: boolean}>`
  box-shadow: rgba(1, 61, 68, 0.1) 0px 0px 10px 2px;
  border-radius: 12px;
  width: 340px;
  background-color: var(--color-white);
  height: fit-content;
  margin-left: 32px;
  margin-top: ${({ marginTop }) => (marginTop ? "35px" : "20px")};
  position: sticky;
  top: 16px;
  margin-bottom: 28px;
`;

export const BasketContent = styled.div`
  padding: 24px;
`;

export const BasketHeader = styled.div`
  display: flex;
  flex-direction: row;
  margin-bottom: 16px;
`;

export const BasketHeaderIcon = styled.img`
  width: 24px;
  height: 24px;
  margin-right: 10px;
`;

export const BasketHeadline = styled.p`
  font-size: 18px;
  color: var(--color-blue-700);
  margin-bottom: 0px;
  font-weight: 600;
`;

export const BasketProgress = styled.div`
  margin-bottom: 32px;
`;

export const BasketProgressText = styled.p`
  margin-bottom: 0px;
  font-size: 12px;
  color: #6b6b6a;
  margin-bottom: 8px;
`;

export const BasketProgressbar = styled.div`
  width: 100%;
  background-color: rgb(229, 231, 235);
  border-radius: 3px;
  height: 8px;
`;

export const BasketProgressFill = styled.div<{ width: number}>`
  height: 8px;
  width: ${({width}) =>  `${width}%`};
  border-radius: 3px;
  background-color: var(--color-petrol);
`;

export const BasketMembershipWrapper = styled.div`
  margin-bottom: 16px;
`;

export const BasketMembershipRow = styled.div`
  margin-bottom: 8px;
  display: flex; 
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
`;

export const BasketPackageRow = styled.div`
  margin-bottom: 8px;
  display: flex; 
  flex-direction: row;
  align-items: end;
  justify-content: space-between;
`;

export const BasketCheckmark = styled(BiCheck)`
  color: var(--color-petrol);
  margin-right: 4px;
  font-size: 22px;
`;

export const BasketProduct = styled.p`
  margin-bottom: 0px;
  font-size: 14px;
`; 

export const BasketProductPrice = styled.p`
  font-weight: 700; 
  margin-bottom: 0px;
  font-size: 14px;
`;

export const BasketUnionOffer = styled.p`
  margin-bottom: 0px;
  color: var(--color-orange);
  margin-left: 25px; 
  margin-top: -8px;
  margin-bottom: 8px;
  font-size: 13px;
`;

export const BasketTotalWrapper = styled.div`
  padding: 24px;
  border-top: 1px solid rgb(221, 225, 232);
  background-color: rgba(0, 142, 159, 0.02);
`;

export const BasketTotalRow = styled.div`
  display: flex; 
  flex-direction: row;
  align-items: end;
  justify-content: space-between;
`;

export const BasketTotalText = styled.p`
  margin-bottom: 0px;
  font-size: 12px;
  color: #6b6b6a;
`;

export const BasketTotal = styled.div`
  font-size: 16px;
`;

export const BasketTotalPrice = styled.div`
  font-size: 22px;
  font-weight: 600;
  color: var(--color-blue-700);
`;

export const BasketValueList = styled.ul`
  font-size: 13px;
  list-style-type: disc;
  margin-top: 20px;
`;

export const BasketValueItem = styled.li`
  color: rgb(107, 107, 106);
`;

export const BasketPackageInfoContainer = styled.div`
  background-color: rgba(0, 142, 159, 0.05);
  border: 1px solid rgba(0, 142, 159, 0.15);
  padding: 16px;
  margin-top: 20px;
  border-radius: 8px;
`;

export const BasketPackageInfoHeader = styled.div`
  display: flex;
  align-items: flex-start;
  margin-bottom: 8px;
`;

export const BasketPackageInfoHeadline = styled.p`
  font-size: 13px;
  font-weight: 700;
  color: rgb(58, 58, 57);
  margin-bottom: 0px;
`;

export const BasketPackageInfoUl = styled.ul`
  font-size: 12px;
  color: rgb(58, 58, 57);
  list-style-type: disc;
  margin-left: 28px;
`;

export const BasketPackageInfoLi = styled.li`
  margin-bottom: 12px;
`;

export const BasketPackageInfoIcon = styled.img`
  width: 18px;
  margin-right: 8px;
`;

export const Contact = styled.a`
  border-bottom-left-radius: 12px;
  border-bottom-right-radius: 12px;
  padding: 10px 24px;
  background-color: var(--color-gray-100);
  font-size: 13px; 
  text-align: center;
  text-decoration: underline;
  border-top: 1px solid rgb(221, 225, 232);
  display: block;
`;

export const InfoText = styled.p`
  font-size: 12px;
  color: rgb(107, 107, 106);
  font-style: italic;
  margin: 13px 0px 0px 0px;
`;